import React, {Component} from 'react'
import {Button, Form, Row, Col, Input, Spin, Switch, TimePicker, Select} from 'antd'
import {inject, observer} from 'mobx-react'
import TextArea from 'antd/es/input/TextArea'
import moment from 'moment'
import UPM from '../../constants/urlPermissionMappings'
import {EditOutlined} from '@ant-design/icons'
import {withTranslation} from 'react-i18next'

@inject('emailManagementStore')
@observer
class emailManagement extends Component {
  state = {
    status: false
  }
  formRef = React.createRef()

  componentDidMount() {
    const {emailManagementStore} = this.props
    emailManagementStore.getAlarm().then(() => {
      this.formRef.current.setFieldsValue({...emailManagementStore.alarmData})
      this.formRef.current.setFieldsValue({'emailTo': emailManagementStore.alarmData.emailTo.split(';')})
      this.formRef.current.setFieldsValue({'emailCc': emailManagementStore.alarmData.emailCc.split(';')})
      this.setState({status: emailManagementStore.alarmData.status})
    })
  }

  onStatusChange = () => {
    this.setState({status: !this.state.status})
  }

  submit = () => {
    const {emailManagementStore} = this.props
    this.formRef.current.validateFields().then(fieldsValue => {
      fieldsValue.sendTime = moment(fieldsValue.sendTime).format('HH:mm:ss')
      fieldsValue.emailCc = fieldsValue.emailCc.join(';')
      fieldsValue.emailTo = fieldsValue.emailTo.join(';')
      fieldsValue.status = this.state.status

      emailManagementStore.alarmSave(fieldsValue)
    })
  }

  render() {
    const {status} = this.state
    const {emailManagementStore, location, t} = this.props
    const {isFetching} = emailManagementStore

    return (
      <Spin spinning={isFetching}>
        <div className="container">
          <Form ref={this.formRef} size="middle" className="searchForm" layout="vertical">
            <div className="searchFormTitle">
              <EditOutlined/> {t(`menu.${UPM.find(item => item.url === location?.pathname)?.pKey}`)}
            </div>
            <Row gutter={[10, 0]}>
              <Col span={8}>
                <Form.Item name="emailTo" label={t(`emailManagement.emailTo`)}
                           rules={[{
                             required: true,
                             message: `${t(`general.pleaseEnter`)} ${t(`emailManagement.apiUrl`)}`
                           }]}>
                  <Select placeholder={t(`general.pleaseEnter`)} mode="tags" tokenSeparators={[';']} dropdownStyle={{display: 'none'}}/>
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item name="emailCc" label={t(`emailManagement.emailCc`)}>
                  <Select placeholder={t(`general.pleaseEnter`)} mode="tags" tokenSeparators={[';']} dropdownStyle={{display: 'none'}}/>
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item name="sendTime" label={t(`emailManagement.sendTime`)}
                           rules={[{
                             required: true,
                             message: `${t(`general.pleaseSelect`)} ${t(`emailManagement.sendTime`)}`,
                           }]}>
                  <TimePicker placeholder={t(`general.pleaseSelect`)} style={{width: '100%', height: '40px'}}/>
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item name="dataTimeRange" label={t(`emailManagement.dataTimeRange`)} initialValue="0"
                           rules={[{
                             required: true,
                             message: `${t(`general.pleaseEnter`)} ${t(`emailManagement.dataTimeRange`)}`,
                           }]}>
                  <Input min={0} type="number" placeholder="0" prefix="EX" suffix="Hour" className="typeNumber"/>
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item name="emailSubject" label={t(`emailManagement.emailSubject`)}
                           rules={[{
                             required: true,
                             message: `${t(`general.pleaseEnter`)} ${t(`emailManagement.emailSubject`)}`,
                           }]}>
                  <Input placeholder={t(`general.pleaseEnter`)} allowClear maxLength={500}/>
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item name="status" label={t(`emailManagement.status`)}>
                  <Switch
                    checked={status}
                    checkedChildren={t(`general.enable`)}
                    unCheckedChildren={t(`general.disable`)}
                    onChange={this.onStatusChange}
                  />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item name="emailHtml" className="email-textarea" label={t(`emailManagement.emailTemplate`)}
                           rules={[{
                             required: true,
                             message: `${t(`general.pleaseEnter`)} ${t(`emailManagement.emailTemplate`)}`,
                           }]}>
                  <TextArea rows={12} placeholder="Please enter ..." allowClear/>
                </Form.Item>
              </Col>
              <Col span={24} style={{textAlign: 'center', paddingBottom: 10}}>
                <Button style={{marginRight: 10}} type="primary" onClick={this.submit}>{t(`general.save`)}</Button>
              </Col>
            </Row>
          </Form>
        </div>
      </Spin>
    )
  }
}

export default withTranslation()(emailManagement)
